import { Component, Input, OnInit } from '@angular/core';

import ClearcalsIcons from 'app/icons/icons.data';

export const StoreData = {
	appStoreRatingFloor : new Array(4),
	appStoreRatingDecimal : true,
	playStoreRatingFloor : new Array(4),
	playStoreRatingDecimal : true,
}

@Component({
	selector: 'clearcals-store-rating',
	templateUrl: './store-rating.component.html',
	styleUrls: ['./store-rating.component.scss'],
})
export class StoreRatingComponent implements OnInit {
	@Input() playStoreImgUrl: string;
	@Input() appStoreImgUrl: string;
	@Input() flexColumn: boolean = false;
	@Input() imgDimension: { width: number; height: number };

	storeData = StoreData;
	
	storeStyle = null;

	// icons
	starIcon = ClearcalsIcons.getIcon('star');
	starHalfIcon = ClearcalsIcons.getIcon('starHalf');

	ngOnInit() {
		this.storeStyle = {
			width: this.imgDimension.width + 'px',
			height: this.imgDimension.height + 'px',
		};
	}
}
